import React from 'react';

// const getColor = (percent) => {
//   if (percent <= 20) return '#990000';       // deep red
//   if (percent <= 40) return '#cc0000';       // red
//   if (percent <= 60) return '#ff9900';       // orange
//   if (percent <= 80) return '#99cc00';       // light green
//   return '#009900';                          // deep green
// };

// Function to linearly interpolate between two values
const interpolate = (value, start, end) => {
  return Math.round(start + (end - start) * value);
}

// Function to get the color between two color stops
const interpolateColor = (value, color1, color2) => {
  const r = interpolate(value, color1[0], color2[0]);
  const g = interpolate(value, color1[1], color2[1]);
  const b = interpolate(value, color1[2], color2[2]);

  // Return the interpolated color as a hex string
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
}

// Main function to return a hex color based on input between 1 and 5
const getColor = (value) => {
  value /= 20;
  
  if (parseInt(value) === -1) return '#808080';

  // Define color stops in RGB
  const clamped = Math.max(0, Math.min(value, 5));

  const colorStops = [
      [128, 0, 0],   // 0 - Dark Red
      [255, 0, 0],   // 1 - Red
      [255, 128, 0], // 2 - Orange
      [255, 255, 0], // 3 - Yellow
      [0, 168, 107],   // 4 - Green
      [0, 191, 255]    // 5 - Blue
  ];

  const baseIndex = Math.floor(clamped);
  const nextIndex = Math.min(baseIndex + 1, colorStops.length - 1);
  const fraction = clamped - baseIndex;

  return interpolateColor(fraction, colorStops[baseIndex], colorStops[nextIndex]);
}

const ArtistScoreBadge = ({ userWeightedScore }) => {
  // if (userWeightedScore === null || userWeightedScore === undefined) return null;

  const percent = Math.round(userWeightedScore * 100);
  const color = getColor(percent);

  return (
    <span style={{
      backgroundColor: userWeightedScore ? color : '#888',
      color: 'white',
      padding: '4px 8px',
      borderRadius: '12px',
      fontWeight: 'bold',
      fontSize: '0.9em',
      display: 'inline-block',
      minWidth: '40px',
      textAlign: 'center',
      textShadow: '0 0 3px rgba(0,0,0,1.75)'
    }}>
      {userWeightedScore ? `${percent}%` : 'N/A' }
    </span>
  );
};

export default ArtistScoreBadge;